export const branchSidebarTranslationJP = {
  BranchSidebar: {
    final_confirmed: '最終確定済',
  },
};
